import HeaderCard from "@/design/components/HeaderCard";
import FormGroup from "@/design/forms/FormGroup";

import { GlobalStyles, Stack } from "@mui/material";
import { grey } from "@mui/material/colors";

import KeyboardShortcut from "./components/KeyboardShortcut";

export default function KeyboardShortcuts() {
  return (
    <Stack spacing={2}>
      <HeaderCard title="Keyboard shortcuts" sx={{ ".MuiCardHeader-title": { my: 0 } }} />
      <GlobalStyles
        styles={(theme) => ({
          kbd: {
            border: `1px solid ${grey[400]}`,
            backgroundColor: grey[200],
            borderBottomWidth: "2px",
            borderRadius: "5px",
            paddingInline: "4px",
            fontSize: "12px",
            display: "inline-block",
            ...theme.applyStyles("dark", {
              borderColor: grey[800],
              backgroundColor: grey[900],
            }),
          },
        })}
      />
      <FormGroup title="Global">
        <KeyboardShortcut name="New resource" keys={["Alt", "N"]} />
        <KeyboardShortcut name="Search" keys={["Alt", "S"]} />
      </FormGroup>
      <FormGroup title="Holiday sets">
        <KeyboardShortcut name="New holiday" keys={["Alt", "H"]} />
        <KeyboardShortcut name="New public holiday" keys={["Alt", "P"]} />
      </FormGroup>
    </Stack>
  );
}
